import React, { Component } from "react";
import PropTypes from "prop-types";
import "./style.scss";

class SvgIcon extends Component {
  /**
   * @returns {ReactElement}
   */
  renderIcon() {
    const {
      fillColor,
      stroke,
      strokeDashArray,
      strokeWidth,
      cursor,
      height,
      icon,
      customClassName,
      link,
      onMouseUp
    } = this.props;

    // Don't really know what to do about this one
    // eslint-disable-next-line import/no-dynamic-require,global-require
    const image = require(`icons/${icon}.svg`);
    const className = customClassName || "";

    return (
      <svg
        viewBox={this.props.viewBox || "0 0 64 64"}
        preserveAspectRatio={this.props.preserveAspectRatio || null}
        className={`SvgIcon${link ? "__custom" : ""} ${className}`}
        onClick={this.props.onClick}
        stroke={stroke}
        strokeDasharray={strokeDashArray}
        strokeWidth={strokeWidth}
        style={({
          cursor,
          height,
          width: height,
          ...(link ? {} : { fill: fillColor })
        })}
        {...onMouseUp}
      >
        <use href={`#${image.default.id}`} />
      </svg>
    );
  }

  renderLinkIcon() {
    const { link, height, fillColor } = this.props;

    return <a href={link} style={{ height, width: height, color: fillColor }} target="_blank" rel="noopener noreferrer">{this.renderIcon()}</a>;
  }

  render() {
    const { link } = this.props;

    return link ? this.renderLinkIcon() : this.renderIcon();
  }
}

SvgIcon.propTypes = {
  height: PropTypes.number,
  icon: PropTypes.string.isRequired,
  customClassName: PropTypes.string
};

SvgIcon.defaultProps = {
  height: null, // set the style to null if one is not provided
  customClassName: ""
};

export default SvgIcon;
